// import { useEffect } from "react";
// import {
//   Box,
//   Paper,
//   Typography,
//   Avatar,
//   IconButton,
//   Slide,
//   Collapse
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";

// const Notification = ({
//   open,
//   notifications = [],
//   expanded,
//   onExpand,
//   onCollapse,
//   onToggle,
//   onClose
// }) => {
//   useEffect(() => {
//     if (!open || expanded) return;

//     const timer = setTimeout(onClose, 4000);
//     return () => clearTimeout(timer);
//   }, [open, expanded, onClose]);

//   if (!open || notifications.length === 0) return null;

//   const first = notifications[0];
//   const rest = notifications.slice(1, 5);

//   return (
//     <Slide direction="left" in={open} mountOnEnter unmountOnExit>
//       <Box
//         onMouseEnter={onExpand}
//         onMouseLeave={onCollapse}
//         sx={{
//           position: "fixed",
//           bottom: 24,
//           right: 24,
//           width: 360,
//           zIndex: 2000,
//           display: "flex",
//           flexDirection: "column"
//         }}
//       >
//         {/* 🔹 Expanded notifications */}
//         <Collapse in={expanded} timeout={250}>
//           <Box sx={{ display: "flex", flexDirection: "column" }}>
//             {rest.map((notif, index) => (
//               <Paper
//                 key={notif.id}
//                 elevation={5}
//                 sx={{
//                   p: 2,
//                   mb: index === rest.length - 1 ? 0 : 0.7, // last card no bottom margin
//                   borderRadius: 3,
//                   display: "flex",
//                   gap: 2,
//                   cursor: "pointer"
//                 }}
//               >
//                 <Avatar sx={{ bgcolor: "primary.main" }}>
//                   {(notif.desc || "U")[0].toUpperCase()}
//                 </Avatar>

//                 <Box sx={{ flex: 1, minWidth: 0 }}>
//                   <Typography fontWeight={700} noWrap>
//                     {notif.title}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary" noWrap>
//                     {notif.desc}
//                   </Typography>
//                   <Typography variant="caption" color="text.disabled">
//                     {notif.time}
//                   </Typography>
//                 </Box>
//               </Paper>
//             ))}
//           </Box>
//         </Collapse>

//         {/* 🔹 Base notification */}
//         <Paper
//           elevation={7}
//           onClick={onToggle}
//           sx={{
//             p: 2.5,
//             borderRadius: 3,
//             display: "flex",
//             gap: 2,
//             cursor: "pointer",
//             position: "relative",
//             mt: 0.7 // ensures spacing from expanded notifications
//           }}
//         >
//           <Avatar sx={{ bgcolor: "primary.main" }}>
//             {(first.desc || "U")[0].toUpperCase()}
//           </Avatar>

//           <Box sx={{ flex: 1, minWidth: 0 }}>
//             <Typography fontWeight={700} noWrap>
//               {first.title}
//             </Typography>
//             <Typography variant="body2" color="text.secondary" noWrap>
//               {first.desc}
//             </Typography>
//             <Typography variant="caption" color="text.disabled">
//               {first.time}
//             </Typography>
//           </Box>

//           <IconButton
//             size="small"
//             onClick={(e) => {
//               e.stopPropagation();
//               onClose();
//             }}
//             sx={{ position: "absolute", top: 6, right: 6 }}
//           >
//             <CloseIcon fontSize="small" />
//           </IconButton>
//         </Paper>
//       </Box>
//     </Slide>
//   );
// };

// export default Notification;



import { useEffect, useRef, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Avatar,
  IconButton,
  Slide,
  Collapse,
  Chip
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNotificationSound } from "../hooks/useNotificationSound";
import { formatWithTZ } from "../utils/TimeZone";

const Notification = ({
  open,
  notifications = [],
  expanded,
  onExpand,
  onCollapse,
  onToggle,
  onClose
}) => {
  const { playSound } = useNotificationSound('/notification.mp3');

  // Play sound when new notifications arrive
  useEffect(() => {
    if (open && notifications.length > 0) {
      playSound();
    }
  }, [open, notifications.length, playSound]);


  const timerRef = useRef(null);

  useEffect(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    if (!open || expanded) return;

    timerRef.current = setTimeout(() => {
      onClose();
    }, 4500);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [open, expanded]); // Note: onClose is NOT in the dependency array

  if (!open || notifications.length === 0) return null;

  const first = notifications[0];
  const rest = notifications.slice(1, 5);

   const getMessageLabel = (msg = "") => {
    if (msg === "Inquiry Follow-up") return "FL";
    if (msg === "New Inquiry") return "IN";
    if (msg === "New Quotation") return "QT";
    if (msg === "New Sale - Order") return "SO";
    if (msg === "Sale - Challan") return "SC";
    if (msg === "Sale - Invoic") return "SI";
    if (msg === "New Purchase Order") return "PO";
    if (msg === "Purchase - Challan") return "PC";
    if (msg === "Purchase - Invoice") return "PI";
    if (msg === "Credit Note") return "CR";
    if(msg === "Debit Note") return "DB";
    return msg;
  };

  const avatarColors = [
    "#e91e63", "#9c27b0", "#673ab7", "#3f51b5",
    "#4caf50", "#8bc34a", "#cddc39", "#ffc107",
    "#ff9800", "#ff5722", "#795548", "#607d8b",
    "#2196f3", "#03a9f4", "#00bcd4", "#009688"
  ];

  const getAvatarColor = (text = "") => {
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % avatarColors.length;
    return avatarColors[index];
  };

  const NotifCard = ({ notif, elevation = 5, onClick, showClose = false }) => {
    const avatarColor = getAvatarColor(notif.client);
    return (
      <Paper
        elevation={elevation}
        onClick={onClick}
        sx={{
          borderRadius: 3,
          overflow: "hidden",
          cursor: "pointer",
          position: "relative",
          borderLeft: `4px solid ${avatarColor}`,
        }}
      >
        {/* Top row: avatar + name + chip + close */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, px: 2, pt: 1.8, pb: 0.8 }}>
          <Avatar sx={{ width: 36, height: 36, bgcolor: avatarColor, color: "#fff", fontWeight: 700, fontSize: "0.95rem", flexShrink: 0 }}>
            {(notif.client || "U")[0].toUpperCase()}
          </Avatar>
          <Typography fontWeight={600} sx={{ flex: 1, minWidth: 0, wordBreak: "break-word", lineHeight: 1.3, fontSize: "0.9rem" }}>
            {notif.client}
          </Typography>
          {notif.message && (
            <Chip label={getMessageLabel(notif.message)} size="small" color="secondary" sx={{ flexShrink: 0, height: 20, fontSize: "0.7rem", fontWeight: 600 }} />
          )}
          {showClose && (
            <IconButton size="small" onClick={(e) => { e.stopPropagation(); onClose(); }} sx={{ ml: 0.5, flexShrink: 0 }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          )}
        </Box>

        {/* Body */}
        <Box sx={{ px: 2, pb: 1.8 }}>
          <Typography fontSize="0.8rem" color="text.secondary" fontWeight={500}>
            Doc: {notif.documentNumber}
          </Typography>
          {(notif.remarks && notif.remarks !== "N/A") && (
            <Typography fontSize="0.78rem" color="text.secondary" sx={{ fontStyle: "italic", mt: 0.2, wordBreak: "break-word" }}>
              {notif.remarks}
            </Typography>
          )}
          {(notif.leadFrom || notif.leadTo) && (
            <Box sx={{ mt: 0.3 }}>
              {notif.leadFrom && <Typography fontSize="0.76rem" color="text.secondary"><strong>From:</strong> {notif.leadFrom}</Typography>}
              {notif.leadTo && <Typography fontSize="0.76rem" color="text.secondary"><strong>To:</strong> {notif.leadTo}</Typography>}
            </Box>
          )}
          <Typography variant="caption" color="text.disabled" sx={{ mt: 0.4, display: "block" }}>
            {notif.raw?.ist_datetime ? (() => { try { return formatWithTZ(notif.raw.ist_datetime); } catch { return notif.time; } })() : notif.time}
          </Typography>
        </Box>
      </Paper>
    );
  };

  return (
    <Slide direction="left" in={open} mountOnEnter unmountOnExit>
      <Box
        onMouseEnter={onExpand}
        onMouseLeave={onCollapse}
        sx={{
          position: "fixed",
          bottom: 24,
          right: 24,
          width: 340,
          zIndex: 2000,
          display: "flex",
          flexDirection: "column",
          gap: 0.8,
        }}
      >
        {/* Expanded stack */}
        <Collapse in={expanded} timeout={250}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.8, mb: 0.8 }}>
            {rest.map((notif) => (
              <NotifCard key={notif.id} notif={notif} elevation={4} />
            ))}
          </Box>
        </Collapse>

        {/* Primary / base notification */}
        <NotifCard notif={first} elevation={8} onClick={onToggle} showClose />
      </Box>
    </Slide>
  );
};

export default Notification;
